function setCacheHas(value) {
  return this.__data__.has(value);
}
module.exports = setCacheHas;
